// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how_it_work_btn .btndefault:first-child {
    background: transparent;
    border: 1px solid #E20F6F;
    text-align: center;
    color: black;
    margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/landingPage/landing1/HowItWork.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".how_it_work_btn .btndefault:first-child {\n    background: transparent;\n    border: 1px solid #E20F6F;\n    text-align: center;\n    color: black;\n    margin-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
